import { defineComponent } from 'vue';
import './index.less';
import { Plugin } from '@vue/runtime-dom';
interface Props {
  title: string;
}

const blueline = defineComponent({
  props: {
    title: { type: String, require: true, default: '' },
  },
  setup(props: Props) {
    return () => (
      <div class="title-with-line">
        <span class="line"></span>
        <span class="title">{props.title}</span>
      </div>
    );
  },
});

export const DBlueLine: Plugin = {
  install: (app) => {
    // Plugin code goes here
    app.component('DBlueline', blueline);
  },
};
